module.exports = "../dist/frontend/icons/symbols/letters/a-blue.svg?2ac7e4387ab17066a42786802e725ce3";